<template>
  <v-layout>
    <v-flex xs12>
      <v-card hover tile color="accent" :max-width="maxWidth" min-width="300" @click="toggleShow">
        <v-card-title primary-title>
          <div class="mb-2">
            <div class="headline mb-1">{{ selected._source.eventTitle }}</div>
            <div class="subHeadline mb-2">
              <em>{{ selected._source.eventLocationName }} - {{ selected._source.executionTime | moment('MMMM D, YYYY h:mm:ss a') }}</em>
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-icon color="primary" v-show="showDropdown">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          <v-spacer></v-spacer>
          <v-btn icon color="primary--text" @click.stop="clickSave" v-show="false">
            <v-icon>{{ bookmark ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}</v-icon>
          </v-btn>
          <v-btn icon v-if="attachments.length !== 0">
            <span class="mr-1">{{ attachments.length }}</span> <v-icon color="primary">mdi-image</v-icon>
          </v-btn>
          <v-btn icon v-if="displayLink.length !== 0">
            <span class="mr-1">{{ displayLink.length }}</span> <v-icon color="primary">mdi-link-variant</v-icon>
          </v-btn>
          <v-btn icon>
            <span class="mr-1">{{ displayTweets.length }}</span> <v-icon color="blue lighten-1">mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon @click="clickShare(selected._id)"> <v-icon color="primary">mdi-share-variant</v-icon> </v-btn>
        </v-card-actions>
        <v-slide-y-transition>
          <v-card-text v-show="show">
            <div class="d-flex">
              <v-flex v-for="n in attachments" :key="n.url" xs3 d-flex>
                <v-card flat tile class="d-flex ma-1" style="position: relative" v-if="n.graphic">
                  <v-img
                    @click.stop="graphicDisplay(n)"
                    gradient="to top right, rgba(0,0,0,.73), rgba(25,32,72,.7)"
                    :src="n.imageUrl"
                    :lazy-src="n.imageUrl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  ></v-img>
                </v-card>
                <v-card flat tile class="d-flex ma-1" v-else>
                  <v-img @click.stop="dialogDisplay(n)" :src="n.imageUrl" :lazy-src="n.imageUrl" aspect-ratio="1" class="grey lighten-2"></v-img>
                </v-card>
              </v-flex>
            </div>
            <v-flex class="blue--text" v-for="(url, index) in displayLink" :key="index">
              <v-icon color="blue lighten-1" class="fittedIcon mr-2">mdi-link-variant</v-icon>
              <a class="tweetLink" @click="clickLink(url)">{{ url.Description }}</a>
              <v-icon v-if="url.graphic" color="black" class="fittedIcon ml-1">mdi-sunglasses</v-icon>
            </v-flex>
          </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" width="800">
      <v-card v-show="attachmentURL.length !== 0">
        <v-img
          v-if="attachmentURL.type === 'photo'"
          :src="attachmentURL.url"
          :lazy-src="attachmentURL.url"
          aspect-ratio="1"
          class="grey lighten-2"
        ></v-img>
        <video
          v-if="attachmentURL.type === 'video'"
          class="video d-flex d-inline-flex align-center justify-center"
          :src="attachmentURL.url"
          controls
          autoplay
        ></video>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EventCard',
  props: {
    mobileState: {
      type: Boolean,
      required: true,
      default: false
    },
    mobileWidth: {
      type: Number
    }
  },
  data() {
    return {
      show: false,
      bookmark: false,
      saved: false,
      dialog: false,
      attachmentURL: {}
    };
  },
  computed: {
    ...mapGetters({
      selected: 'selected'
    }),
    attachments() {
      return this.selected._source.attachments.filter(a => {
        if (a.deleted && a.hasOwnProperty('deleted')) {
          return;
        } else {
          return ['photo', 'video'].includes(a.type);
        }
      });
    },
    displayTweets() {
      return this.selected._source.tweets.filter(t => {
        if (t.deleted && t.hasOwnProperty('deleted')) {
          return;
        } else {
          const Description = t.status.text.length > 90 ? t.status.text.slice(0, 90) + '...' : t.status.text;
          Object.assign(t, { Description });
          return t;
        }
      });
    },
    displayLink() {
      return this.selected._source.attachments.filter(t => {
        if (t.type === 'url') {
          if (t.deleted && t.hasOwnProperty('deleted')) {
            return;
          } else {
            let Description;
            if (this.mobileState) {
              Description = t.url.length > 40 ? t.url.slice(0, 40) + '...' : t.url;
            } else {
              Description = t.url.length > 70 ? t.url.slice(0, 70) + '...' : t.url;
            }
            // const Description = t.url.length > 40 ? t.url.slice(0, 40) + '...' : t.url;
            Object.assign(t, { Description });
            return t;
          }
        }
      });
    },
    showDropdown() {
      if (this.displayLink.length !== 0 || this.attachments.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    maxWidth() {
      if (this.mobileState) {
        return this.mobileWidth;
      } else {
        return '700';
      }
    }
  },
  methods: {
    clickShare(identification) {
      let url = 'http://newsdeck.evntl.com/story/';
      let encoded = encodeURI(url.concat('', identification));
      window.open(encoded, '_blank');
    },
    clickSave() {
      this.bookmark = !this.bookmark;
    },
    toTweetLink(tweet) {
      if (tweet.hasOwnProperty('urls')) {
        if (tweet.urls.length !== 0) {
          window.open(encodeURI(tweet.urls[0]), '_blank');
        } else {
          alert('No links on file');
        }
      } else if (tweet.status.hasOwnProperty('retweetedStatus')) {
        let indexStart = tweet.status.retweetedStatus.text.indexOf('https://');
        let indexEnd = tweet.status.retweetedStatus.text.indexOf(' ', indexStart);
        if (indexEnd == -1) {
          if (tweet.status.retweetedStatus.text.slice(indexStart, tweet.status.retweetedStatus.text.length).length !== 0) {
            window.open(encodeURI(tweet.status.retweetedStatus.text.slice(indexStart, tweet.status.retweetedStatus.text.length)), '_blank');
          } else {
            alert('No links on file');
          }
        } else {
          if (tweet.status.retweetedStatus.text.slice(indexStart, indexEnd).length !== 0) {
            window.open(encodeURI(tweet.status.retweetedStatus.text.slice(indexStart, indexEnd)), '_blank');
          } else {
            alert('No links on file');
          }
        }
      }
    },
    clickLink(url) {
      this.$ga.event('send', {
        eventCategory: 'Events',
        eventAction: 'Clicked on external link'
      });
      if (url.hasOwnProperty('graphic') && url.graphic) {
        let confirmation = confirm('You are about to open a sensitive content');
        if (confirmation) {
          window.open(url.url, '_blank');
        }
      } else {
        window.open(url.url, '_blank');
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    graphicDisplay(attachment) {
      let confirmation = confirm('You are about to open a sensitive content');
      if (confirmation) {
        this.dialog = !this.dialog;
        attachment.graphic = false;
        this.attachmentURL = attachment;
      }
    },
    dialogDisplay(attachment) {
      this.dialog = !this.dialog;
      this.attachmentURL = attachment;
    }
  }
};
</script>

<style scoped>
.tweetLink {
  text-decoration: none;
  cursor: pointer;
  color: dodgerblue;
}
.fittedIcon {
  font-size: 1.2rem;
}
.video {
  background-size: 100% 100%;
  top: 0px;
  left: 0px; /* fixed to left. Replace it by right if you want.*/
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: fill;
}
.headline {
  color: #085280;
  font-size: 1.4rem !important;
  font-weight: 500 !important;
}
.subHeadline {
  font-size: 1rem;
}
.graphicContentBackground {
  height: 50px;
  width: 50px;
  background: #1f1f1f;
  opacity: 0.95;
  width: 100%;
  height: 100%;
  -webkit-filter: blur(10px);
  filter: blur(10px);
}
</style>
